import React, { useState } from "react";
import { Button, Tab } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import {
  SupportList,
  SupportForm,
} from "../../../../components/SupportComponent";
// F5 - Autogestion de la suscripcion Stripe. Vive en Soporte (no en Perfil)
// a proposito: decision Antonio 2026-07-22, no queremos la baja tan a la
// vista. Solo se renderiza para compradores web (hasStripeSubscription).
import { InstitutionSubscription } from "../../../../components/Admin/InstitutionCmp/InstitutionProfile";
import { useAuth } from "../../../../hooks";
import { useTranslation } from "react-i18next";
import "./Page_Institution_Support.scss";

export function Page_Institution_Support() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);
  const { accessToken, user } = useAuth();
  const { t } = useTranslation("support");

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <SupportList
            reload={reload}
            onReload={onReload}
            user={user}
            accessToken={accessToken}
          />
        </Tab.Pane>
      ),
    },
  ];

  // Solo si NO eres partner, deberías poder "Crear Ticket"
  // (Asumiendo que esa es la lógica deseada.)
  const canCreateTicket = user?.role !== "partner";

  return (
    <>
      <div className="institution-profile-page">
        <div className="support-page__add">
          {canCreateTicket && (
            <Button className="button-teacher" onClick={onOpenCloseModal}>
              {t("pages.newTicketButton")}
            </Button>
          )}
        </div>

        <Tab menu={{ secondary: true }} panes={panes} />

        <InstitutionSubscription />
      </div>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={t("pages.createTicketTitle")}
        size="large"
      >
        <SupportForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          user={user}
          accessToken={accessToken}
        />
      </BasicModal>
    </>
  );
}
